import { useState } from 'react';
import {
  StyledAccordionItem,
  StyledToggleLabel,
  StyledToggle,
  StyledToggleCircle,
  StyledContentContainer,
  StyledRichText,
} from './AccordionItem.styles';
import { graphql } from 'gatsby';
import { isRichTextValid } from '../../../RichTextBlock/utils';
import useResolveRichTextInternalLink from '../../../RichTextBlock/hooks/useResolveRichTextInternalLink';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import Icon from '@/components/Icon/IconSprite.tsx';

interface AccordionItemProps {
  elements: Queries.ACCORDION_ITEMFragment['elements'];
  system: Queries.ACCORDION_ITEMFragment['system'];
}

const AccordionItem = ({ elements, system }: AccordionItemProps) => {
  const { headline, content, initial_state } = elements;
  const [isItemActive, setItemActive] = useState(initial_state?.value === 'expanded');
  const resolveRichTextInternalLink = useResolveRichTextInternalLink();

  return (
    <StyledAccordionItem isActive={isItemActive}>
      <StyledToggle
        onClick={() => setItemActive(!isItemActive)}
        aria-controls={system.id}
        aria-expanded={isItemActive}
      >
        <StyledToggleLabel>{headline.value}</StyledToggleLabel>
        <StyledToggleCircle>
          <Icon className="icon" name="bx-chevron-right" />
        </StyledToggleCircle>
      </StyledToggle>

      <StyledContentContainer aria-hidden={!isItemActive} id={system.id}>
        {isRichTextValid(content.value) && (
          <StyledRichText>
            <RichTextElement {...content} resolveLink={resolveRichTextInternalLink} />
          </StyledRichText>
        )}
      </StyledContentContainer>
    </StyledAccordionItem>
  );
};

export default AccordionItem;

export const fragment = graphql`
  fragment ACCORDION_ITEM on kontent_item_accordion_item {
    elements {
      headline {
        value
      }
      content {
        value
        links {
          link_id
          codename
        }
      }
      initial_state {
        value
      }
    }
    system {
      id
    }
  }
`;
